module.exports = __webpack_public_path__ + "Trip-Cancellation-New-h.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/images/Trip-Cancellation-New-h.png
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/images/Trip-Cancellation-New-h.png
// module chunks = 15